import React from 'react';
  import {
    Box,
    Button,
    TextField,
    useMediaQuery,
    useTheme,
    MenuItem
  } from "@mui/material";
  import { Formik } from "formik";
  import * as yup from "yup";
  import { useSelector } from "react-redux";
  import {  requester } from 'api/pesabackend';
  import { useState, useEffect, useCallback } from 'react';

  const itemTypeSchema = yup.object().shape({
    related_category: yup.number().required("required"),
    sub_category_name: yup.string().required("required"),
  });
  
  
  
  const ItemSubCategoryForm = (props) => {
    

    const pageType = props.formType;
    let {id} = props;
    const userId = useSelector((state) => state.authReducer.user.userId);
    const business_id = useSelector((state) => state.authReducer.business_id);
    const business_branch_id = useSelector((state) => state.authReducer.business_branch_id);
    const { palette } = useTheme();
    const isNonMobile = useMediaQuery("(min-width:600px)");
    const isNew = pageType === "create";
    const isEdit = pageType === "edit";

    const [categoryList, setCategoryList] = useState([]);

    const fetchCategoryList = useCallback(async (search) => {
      try {
        const response = await requester.get(
          `/inventory/product_categories/list?business_branch=${business_branch_id}&search=${search}`
        );
        setCategoryList(response.data.data);
      } catch (e) {
      }
    }, [business_branch_id]);

    useEffect(() => {
      fetchCategoryList("false");
    }, [fetchCategoryList]);
    
    const initialValuesItemType = {
      related_category: "",
      sub_category_name: "",
    };
    
  
    const saveItemType = async (values, onSubmitProps) => {
      values.related_business = business_id
      values.related_business_branch = business_branch_id
      values.added_by = userId
  
      const savedTypeResponse = await requester.post(`/inventory/product_sub_categories/add`, JSON.stringify(values));

      if (savedTypeResponse.data.status === 201) {
        onSubmitProps.resetForm();
        props.setIsSuccess(true);
        props.setNewItemSubCategoryData(true);
        props.setOpen(false);
      }
    };
  
    const editItemType = async (values, onSubmitProps) => {
      const savedTypeResponse = await requester.post(`/inventory/product_sub_categories/edit/${id}`, JSON.stringify(values));

      if (savedTypeResponse.data.status === 201) {
        onSubmitProps.resetForm();
        props.setIsSuccess(true);
        props.setNewItemTypeData(true);
        props.setOpen(false);
      }
    };

  
    const handleFormSubmit = async (values, onSubmitProps) => {
      if (isNew) await saveItemType(values, onSubmitProps);
      if (isEdit) await editItemType(values, onSubmitProps);
    };
  
    return (
      <Formik
        onSubmit={handleFormSubmit}
        initialValues={
          initialValuesItemType 
        }
        validationSchema={itemTypeSchema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
        }) => (
          <form onSubmit={handleSubmit}>
            <Box
              display="grid"
              gap="30px"
              gridTemplateColumns="repeat(4, minmax(0, 1fr))"
              sx={{
                "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
              }}
            >
              <TextField
                label="Parent Category"
                onBlur={handleBlur}
                select
                onChange={handleChange}
                value={values.related_category}
                name="related_category"
                error={Boolean(touched.related_category) && Boolean(errors.related_category)}
                helperText={touched.related_category && errors.related_category}
                sx={{ gridColumn: "span 2" }}
              >
                {categoryList.map((row, index)=>{
                  return(
                  <MenuItem key={index} value={row.id} >{row.category_name}</MenuItem>
                  );
                })}
              </TextField>

              <TextField
                label="Item Sub-Category Name"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.sub_category_name}
                name="sub_category_name"
                error={Boolean(touched.sub_category_name) && Boolean(errors.sub_category_name)}
                helperText={touched.sub_category_name && errors.sub_category_name}
                sx={{ gridColumn: "span 2" }}
              />
            </Box>

            {/* BUTTONS */}
            <Box>
              <Button
                fullWidth
                type="submit"
                disabled={isSubmitting}
                sx={{
                  m: "1rem 0",
                  p: "1rem",
                  backgroundColor: palette.primary.main,
                  color: palette.background.alt,
                  "&:hover": { color: palette.primary.main },
                }}
              >
                Save
              </Button>
            </Box>
          </form>
        )}
      </Formik>
    );
  };
  
  export default ItemSubCategoryForm;
  